import { render, staticRenderFns } from "./CopySummaryCollapses.vue?vue&type=template&id=d552a46e&scoped=true"
import script from "./CopySummaryCollapses.vue?vue&type=script&lang=js"
export * from "./CopySummaryCollapses.vue?vue&type=script&lang=js"
import style0 from "./CopySummaryCollapses.vue?vue&type=style&index=0&id=d552a46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d552a46e",
  null
  
)

export default component.exports